module.exports = __webpack_public_path__ + "static/media/stella-johnson.7c9e1b58.png";